import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'shiprocket-address-banner',
  templateUrl: './shiprocket-address-banner.html',
  standalone: false,
})
export class ShiprocketAddressBannerComponent {
  @Input() shiprocketAddressesCount: number = 0;
  @Output() findMyAddress = new EventEmitter<void>();
  @Output() selectAddress = new EventEmitter<void>();

  constructor(private readonly eventLogger: EventLoggerService) {}

  onBannerClick(): void {
    if (this.shiprocketAddressesCount === 0) {
      this.trackBannerClick('findAddress');
      this.findMyAddress.emit();
      return;
    }
    this.trackBannerClick('selectAddress', this.shiprocketAddressesCount);
    this.selectAddress.emit();
  }

  private trackBannerClick(cta: string, totalAddressFound?: number): void {
    const eventData: { name: string; cta: string; total_address_found?: number } = {
      name: 'shiprocket_address_banner',
      cta,
    };
    if (totalAddressFound !== undefined) {
      eventData.total_address_found = totalAddressFound;
    }
    this.eventLogger.cleverTapEvent('click', JSON.stringify(eventData));
  }
}
